import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@awesome.me/kit-70c1f0055f/icons/classic/regular";
import Logo from "@/components/Logo";
import { fetchImageAsBlobUrl } from "@/services/api/images";
import {
  apiImageUrlNeedsSessionFetch,
  toProxyUrl,
} from "@/utils/imageUrl";

export function HomeBrandLogo({
  logoUrl,
  className,
  testId,
}: {
  logoUrl: string;
  className?: string;
  testId?: string;
}) {
  const [src, setSrc] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    let blobUrl: string | null = null;

    async function load() {
      const proxied = toProxyUrl(logoUrl);
      if (!proxied) {
        setSrc(null);
        return;
      }
      if (apiImageUrlNeedsSessionFetch(proxied)) {
        const resolved = await fetchImageAsBlobUrl(proxied);
        if (!cancelled) {
          blobUrl = resolved;
          setSrc(resolved);
        }
      } else if (!cancelled) {
        setSrc(proxied);
      }
    }

    load();

    return () => {
      cancelled = true;
      if (blobUrl?.startsWith("blob:")) {
        URL.revokeObjectURL(blobUrl);
      }
    };
  }, [logoUrl]);

  if (!src) {
    return (
      <div className="flex h-full min-h-12 w-12 items-center justify-center" data-testid={testId}>
        <FontAwesomeIcon icon={faSpinner} className="h-3.5 w-3.5 animate-spin text-slate-500" />
      </div>
    );
  }

  return (
    <img
      src={src}
      alt="Company logo"
      className={className}
      data-testid={testId}
    />
  );
}

export function HomeBrandFallback({
  className,
  testId,
}: {
  className?: string;
  testId?: string;
}) {
  return <Logo data-testid={testId} className={className} />;
}
